import { type Scope, createContextScope } from '@radix-ui/react-context'
import type React from 'react'
import { forwardRef } from 'react'
import type { ViewProps } from 'react-native'
import { ToastDescription } from './components/toast-description'
import { ToastIcon } from './components/toast-icon'
import * as T from './toast.styles'
import type { ToastProps } from './toast.types'

export const DISPLAY_NAME = 'Toast'

type ToastRootProps = ToastProps &
  ViewProps & {
    children: React.ReactNode
  }

const ToastRoot = forwardRef<React.ElementRef<typeof T.Root>, ToastRootProps>(
  (props, ref) => {
    const { children, __scopeToast } = props as ScopedProps<ToastRootProps>

    return (
      <ToastProvider {...props} scope={__scopeToast}>
        <T.Root ref={ref} {...props}>
          {children}
        </T.Root>
      </ToastProvider>
    )
  }
)

export const Toast = {
  Root: ToastRoot,
  Description: ToastDescription,
  Icon: ToastIcon,
}

/*
----------------------------------------------------------------
Scope Definition
----------------------------------------------------------------
*/

export type ScopedProps<P> = P & {
  __scopeToast?: Scope
}

type ToastContext = ToastProps

const [createToastContext] = createContextScope(DISPLAY_NAME)

export const [ToastProvider, useToastContext] =
  createToastContext<ToastContext>(DISPLAY_NAME)
